import { render, staticRenderFns } from "./battery-outline.vue?vue&type=template&id=20b0162a&scoped=true&"
import script from "./battery-outline.vue?vue&type=script&lang=js&"
export * from "./battery-outline.vue?vue&type=script&lang=js&"
import style0 from "./battery-outline.vue?vue&type=style&index=0&id=20b0162a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0162a",
  null
  
)

export default component.exports